module.exports = __webpack_public_path__ + "assets/img/d326-mx.svg";